export { default } from './PaperBadge';
